// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1et_-","title":"AfterBackImages_title__3SrV_","images":"AfterBackImages_images__2z5Zi"};